import { RankemDetails } from "model/PickemDetails/Rankem/Details";
import { TournamentSegment } from "model/Tournament/Segment/TournamentSegment";
import { BracketRankemPicker } from "./BracketRankemPicker";
import { MatchRankemPicker } from "./MatchRankemPicker";
import { Pick } from "model/Pickem/Pickem";
import { PickersContainer } from "../styles";
import { getPointsPartitionRangeSize } from "model/PickemDetails/PointsPartition";

interface Props {
  rankemDetails: RankemDetails;
  tournamentSegment: TournamentSegment;
  matchIds: string[];
  picks: {
    [id: string]: Pick;
  };
  updatePicks: (newPicks: { id: string; pick: Pick }[]) => void;
}

export const RankemPicker = ({
  rankemDetails,
  tournamentSegment,
  matchIds,
  picks,
  updatePicks,
}: Props) => {
  const updatePick = (
    rosterId: string,
    groupRosterIds: string[],
    position: number | undefined
  ) => {
    const pickPartition = rankemDetails.pointsRules.columns.find(
      (c) => c.position === position
    );
    if (!pickPartition) {
      return;
    }

    const otherRosterIds = groupRosterIds.filter((id) => id !== rosterId);
    const otherPicks = otherRosterIds.map((id) => picks[id]);
    const partitionSize = getPointsPartitionRangeSize(pickPartition);
    if (
      otherPicks.filter((p) => p === pickPartition.position).length >=
      partitionSize
    ) {
      return;
    }

    const currentPick = picks[rosterId];
    updatePicks([
      {
        id: rosterId,
        pick: currentPick !== position ? position : undefined,
      },
    ]);
  };

  const columns = rankemDetails.pointsRules.columns;

  if (tournamentSegment.type === "Bracket") {
    return (
      <PickersContainer>
        {tournamentSegment.groups.map((bracket) => (
          <BracketRankemPicker
            details={rankemDetails}
            bracket={bracket}
            columns={columns}
            picks={picks}
            updatePick={updatePick}
          />
        ))}
      </PickersContainer>
    );
  }

  return (
    <PickersContainer>
      {matchIds.map((matchId) => (
        <MatchRankemPicker
          matchId={matchId}
          tournamentId={rankemDetails.tournamentId}
          columns={columns}
          picks={picks}
          updatePick={updatePick}
          frozenRosters={rankemDetails.frozenRosters}
        />
      ))}
    </PickersContainer>
  );
};
